import React, { useRef, useState } from 'react'
import { connect } from "react-redux";
import { Card, Button } from 'reactstrap';
//components
import ProductImagePreView from "../products/ProductImagePreView";
import Index from "../../common/Components/Index";
import Loader from '../../common/Components/Loader/Loader';
import { HeaderCatalogueProductData } from './Header';
import useProductDataLoop from './useProductDataLoop';
import notifications from '../../common/Components/Notifications/Notification';
import HKPConfirmDialog from '../../common/Components/HKPConfirmDialog';
import { catalogueRemovalError, catalogueRemovalSuccess, confirmedCatalogueRemoval } from '../../components/catalogue/catalogueRemoval';
//actions
import {
    getProductsByCatAlogueId,
    deleteProductInCatAlogue,
} from "../../Store/catelogue/actions";
import { isArray } from 'lodash';
import arrowUpIcon from "./assets/images/icons8-arrow-up-48.png";
import arrowDownIcon from "./assets/images/icons8-expand-arrow-26.png";

let catalogDataProduct: any = [];
const AdminproductData = (props: any) => {
    const [confirmOpen, setConfirmOpen] = useState(false);
    const [removing, setRemoving] = useState(false);
    const removalInFlight = useRef(false);
    let {
        catalogueId,
        catalogueProductToggal,
        handleCatalogueProductToggal,
        openPreview,
        handlePreview,
        image,
        checkedProductData,
        offset,
        limit,
        totPages,
        totCnt,
        toVal,
        fromVal,
        handlePageChange,
        getAllCatalogueProductData,
        onRemoved,
        data,
        loading,
        handleResetCheckboxes
    } = props;
    const deleteProductFromCatalogue = () => {
        const requestedIds: string[] = [...checkedProductData];
        if (removalInFlight.current || !requestedIds.length || requestedIds.some(id => !id)) return;
        removalInFlight.current = true;
        setRemoving(true);
        props.deleteProductInCatAlogue({ productIds: requestedIds }, catalogueId, (res: any) => {
            removalInFlight.current = false;
            setRemoving(false);
            setConfirmOpen(false);
            const result = confirmedCatalogueRemoval(res, requestedIds);
            if (result) {
                notifications({
                    title: "Products removed",
                    message: catalogueRemovalSuccess(result),
                    type: "success",
                });
                onRemoved(result);
                handleResetCheckboxes();
            } else {
                notifications({
                    title: "Products not removed",
                    message: catalogueRemovalError(res),
                    type: "danger",
                    duration: 6000,
                });
            }
        })

    }
    return (
        <>
            <HKPConfirmDialog
                open={confirmOpen}
                title="Remove products from catalogue?"
                description={`Remove ${checkedProductData.length} selected product${checkedProductData.length === 1 ? '' : 's'} from this catalogue? The products will remain in inventory.`}
                confirmLabel="Remove products"
                busy={removing}
                onCancel={() => setConfirmOpen(false)}
                onConfirm={deleteProductFromCatalogue}
            />
            {openPreview && (
                <ProductImagePreView
                    {...props}
                    openModal={openPreview}
                    closeModal={handlePreview}
                    images={image}
                />
            )}
            <Card className='catalogue-product-card'>
                <div className='catalogue-product'>
                    <div>
                        Catalogue Products
                        <Button className='catalogue-btn'
                            disabled={!checkedProductData?.length || removing}
                            onClick={() => setConfirmOpen(true)}
                        >Remove Products From Catalogue</Button>

                    </div>

                    <div>
                        {
                            catalogueProductToggal ?
                                <img className='cursor-pointer'
                                    onClick={() => {
                                        handleCatalogueProductToggal()
                                    }}
                                    src={arrowUpIcon} width={20} height={20} alt="Arrow Up" />
                                : <img className='cursor-pointer'
                                    onClick={() => {
                                        handleCatalogueProductToggal()
                                    }}
                                    src={arrowDownIcon} width={20} height={20} alt="Arrow Up" />
                        }

                    </div>
                </div>

            </Card>
            {
                catalogueProductToggal &&
                <>
                    {
                        data?.length >= 0 ?
                            <>
                                <Index
                                    {...props}
                                    data={data}
                                    headerData={HeaderCatalogueProductData}
                                    limit={limit}
                                    handleChange={handlePageChange}
                                    offset={offset}
                                    totPages={totPages}
                                    loading={loading}
                                    fromVal={fromVal}
                                    toVal={toVal}
                                    totCnt={totCnt}
                                    message="No products added into catalogue"
                                />

                            </> : <>
                            </>
                    }</>
            }



        </>
    )
}
export default connect(null, {
    getProductsByCatAlogueId,
    deleteProductInCatAlogue
})(AdminproductData);
